import { HttpRoot } from '../config/'
const exentionId = document.getElementById('j_little_star_extention_id') && document.getElementById('j_little_star_extention_id').innerText

// 获取cookie
export const getCookie = (name) => {
  return new Promise((resolve, reject) => {
    if (!exentionId || typeof chrome === 'undefined') {
      reject('no chrome')
      return
    }
    if (!chrome.cookies) {
      resolve('')
    }
    chrome.cookies.get({
      url: HttpRoot,
      name,
    }, (result) => {
      resolve(result ? result.value : '')
    })
  })
}

// 设置cookie
export const setCookie = (name, value) => {
  return new Promise((resolve, reject) => {
    if (!exentionId || typeof chrome === 'undefined') {
      reject('no chrome')
      return
    }
    if (!chrome.cookies) {
      resolve('')
    }
    chrome.cookies.set({
      url: HttpRoot,
      name,
      value,
    }, (result) => {
      resolve(result)
    })
  })
}

// 获取或者保存localStorage
export const localStorage = ({ type, data, key }) => {
  return new Promise((resolve, reject) => {
    if (!exentionId || typeof chrome === 'undefined') {
      reject('no chrome')
      return
    }
    chrome.runtime.sendMessage(exentionId, {
      type,
      data,
      key,
    }, (res, err) => {
      if (res && res.type === 'success') {
        resolve(res.data)
      } else {
        reject(err)
      }
    })
  })
}

// 获取或者保存indexdb
export const indexdb = ({ type, data, key }) => {
  return new Promise((resolve, reject) => {
    if (!exentionId || typeof chrome === 'undefined') {
      reject('no chrome')
      return
    }
    chrome.runtime.sendMessage(exentionId, {
      type,
      data,
      key,
    }, (res, err) => {
      if (res && res.type === 'success') {
        resolve(res.data)
      } else {
        reject(err)
      }
    })
  })
}

// 发送请求
export const reqwestByBg = (method, url, data, options) => {
  return new Promise((resolve, reject) => {
    if (!exentionId || typeof chrome === 'undefined') {
      reject('no chrome')
      return
    }
    chrome.runtime.sendMessage(exentionId, {
      type: 'request',
      data: {
        method,
        url,
        data,
        options,
      },
    }, (res, err) => {
      if (res && res.type === 'success') {
        resolve(res.data)
      } else {
        reject(res.err)
      }
    })
  })
}

// 发送请求
export const updateStar = () => {
  return new Promise((resolve, reject) => {
    if (!exentionId || typeof chrome === 'undefined') {
      reject('no chrome')
      return
    }
    chrome.runtime.sendMessage(exentionId, {
      type: 'updateStar',
    }, (res, err) => {
      if (res && res.type === 'success') {
        resolve(res.data)
      } else {
        reject(err || res.err)
      }
    })
  })
}

// 更新content page的内容
export const updateContentPage = (msg) => {
  if (typeof chrome !== 'undefined' && chrome.tabs) {
    chrome.tabs.query({ url: 'https://github.com/*' }, (tabs) => {
      tabs.forEach((tab) => {
        chrome.tabs.sendMessage(tab.id, msg)
      })
    })
  }
}
